module.exports = __webpack_public_path__ + "static/media/APISideBanner.69145e85.svg";